export default "__VITE_ASSET__Cr_ldroE__"